import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Typography,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
} from "@material-ui/core";
import { AccountCircle, Brightness4, Brightness7 } from "@material-ui/icons";
import { ThemeContext } from "../../../Context/Theme";
import Auth from "@aws-amplify/auth";
import { AuthContext } from "../../../Context/Auth";
import { RouteContext } from "../../../Context/RouteContext";

//Component

const DesktopView = ({ classes }) => {
  const { dark, toggle } = useContext(ThemeContext);
  const { logout } = useContext(AuthContext);
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const { resetRoute } = useContext(RouteContext);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function signOut() {
    Auth.signOut()
      .then((data) => {
        logout();
        localStorage.clear();
        resetRoute();
      })
      .catch((err) => {});
  }

  const handleReset = () => {
    handleClose();
    history.replace("reset-password");
  };

  return (
    <>
      <Typography className={classes.ml20} variant="subtitle1" color="primary">
        Admin
      </Typography>
      <Tooltip
        styles={{
          display: "flex",
          zIndex: "400000000",
          backgroundColor: "red",
        }}
        title={dark ? "Toggle light mode" : "Toggle dark mode"}
        arrow
        aria-label="dark_mode_status"
      >
        <IconButton
          onClick={toggle}
          className={classes.ml20}
          disableRipple
          disableTouchRipple
          data-testid={`darkModeButton`}
        >
          {!dark ? (
            <Brightness4 className={classes.accountIconStyles} />
          ) : (
            <Brightness7 className={classes.accountIconStyles} />
          )}
        </IconButton>
      </Tooltip>
      <IconButton
        onClick={handleClick}
        className={classes.ml20}
        disableRipple
        disableTouchRipple
      >
        <AccountCircle className={classes.accountIconStyles} />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        data-testid={`userActionButton`}
      >
        <MenuItem data-testid={`resetPasswordButton`} onClick={handleReset}>
          Reset Password
        </MenuItem>
        <MenuItem data-testid={`logoutButton`} onClick={signOut}>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
};

export default DesktopView;
